import { render, staticRenderFns } from "./certificateRepository.vue?vue&type=template&id=062cf0a2&scoped=true&"
import script from "./certificateRepository.vue?vue&type=script&lang=js&"
export * from "./certificateRepository.vue?vue&type=script&lang=js&"
import style0 from "./certificateRepository.vue?vue&type=style&index=0&id=062cf0a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062cf0a2",
  null
  
)

export default component.exports